<template>
    <transition name="right" mode="out-in">
        <keep-alive>
            <component :is="compName" v-bind.sync="editProps" />
        </keep-alive>
    </transition>
</template>
<script>
import JsrymdBrowse from "./JsrymdBrowse";
import JsrymdView from "./JsrymdView";
export default {
    name: "Dwzcsq",
    components: { JsrymdBrowse, JsrymdView },
    data() {
        return {
            editProps: {
                // 当前记录ID
                dataId: null,
                // 是否编辑状态
                showView: false
            }
        };
    },
    computed: {
        compName() {
            if (this.editProps.showView === true) {
                return "JsrymdView";
            } else {
                return "JsrymdBrowse";
            }
        }
    }
};
</script>
